<ideal-product-long-description-view [description]="description()"></ideal-product-long-description-view>
